import { ComponentType, SVGProps } from "react";

// Assets
import Loads from "../icons/Loads.svg";
import LorryFleetOwner from "../icons/LorryFleetOwner.svg";
import LorryTransportContractor from "../icons/LorryTransportContractor.svg";
import LorryAgentBroker from "../icons/LorryAgentBroker.svg";

export interface ServiceTypeOption {
    label: string;
    value: string;
    description: string;
    icon: ComponentType<SVGProps<SVGSVGElement>>;
}
export const SERVICE_TYPE_OPTIONS: ServiceTypeOption[] = [
    {
        label: "I am a Shipper/Load Owner",
        value: "Shipper",
        description: "I have loads and I am searching for trucks",
        icon: Loads
    },
    {
        label: "I am a Lorry Owner/Driver",
        value: "Fleet Owner",
        description: "I have truck(s) and I am looking for loads",
        icon: LorryFleetOwner
    },
    {
        label: "I own/work for a Transport company",
        value: "Transport Contractor",
        description: "I am searching for both loads and lorries",
        icon: LorryTransportContractor
    },
    {
        label: "I am an Agent/Broker",
        value: "Agent/Broker",
        description: "I don’t own loads or lorries but I act as a dealer between load and lorry owner",
        icon: LorryAgentBroker
    }
];
